import { api } from '../../client';

export interface AccountDto {
  id: string;
  code: string;
  name: string;
  type: string;
  subtype: string;
  description: string;
  balance: number;
  status: string;
}

export const accountingChartsApi = {
  async list(search?: string): Promise<{ data?: AccountDto[]; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/accounting/charts${q}`) as Promise<{ data: AccountDto[] }>;
  },

  async create(data: {
    code: string;
    name: string;
    type: string;
    subtype: string;
    description: string;
  }): Promise<{ data?: AccountDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/accounting/charts', data) as Promise<{ data: AccountDto; message?: string; errors?: Record<string, string[]> }>;
  },

  async update(
    id: string,
    data: { code?: string; name?: string; type?: string; subtype?: string; description?: string }
  ): Promise<{ data?: AccountDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/accounting/charts/${id}`, data) as Promise<{ data: AccountDto; message?: string; errors?: Record<string, string[]> }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/accounting/charts/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
